import { lazy } from 'react';

export const PrivacyPolicyPageAsync = lazy(() => import('./PrivacyPolicyPage'));
